import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Footer from "../main/Footer";
import { isAutheticated } from "../auth/authhelper";
import { API } from "../../API";

export default function ProductClicks() {
    const { token } = isAutheticated();

    const [data, setData] = useState([]);
    const [showData, setShowData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(15);

    // 🔹 Modal State
    const [showModal, setShowModal] = useState(false);
    const [selectedClicks, setSelectedClicks] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState("");
    // 🔹 Modal Pagination
    const [modalPage, setModalPage] = useState(1);
    const [modalPerPage, setModalPerPage] = useState(5);

    // 🔹 Fetch Product Click Analytics
    const loadData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${API}/api/analytics/Product_click/getAll`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            setData(res.data.data || []);
        } catch (err) {
            console.error("Failed to load product clicks", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);
    // 🔹 Modal Pagination Logic
    const modalLastIndex = modalPage * modalPerPage;
    const modalFirstIndex = modalLastIndex - modalPerPage;
    const modalData = selectedClicks.slice(modalFirstIndex, modalLastIndex);
    // 🔹 Pagination logic
    useEffect(() => {
        const indexOfLast = currentPage * itemPerPage;
        const indexOfFirst = indexOfLast - itemPerPage;
        setShowData(data.slice(indexOfFirst, indexOfLast));
    }, [data, currentPage, itemPerPage]);


    // 🔹 Open Modal
    const openClicksModal = (item) => {
        setSelectedClicks(item.clicks || []);
        setSelectedProduct(item.productName);
        setModalPage(1);
        setShowModal(true);
    };

    const closeClicksModal = () => {
        setShowModal(false);
        setSelectedClicks([]);
        setSelectedProduct("");
    };
    const formatUSDateTime = (date) => {
        if (!date) return "—";
        return new Date(date).toLocaleString("en-US", {
            month: "short",   // Nov
            day: "2-digit",   // 26
            year: "numeric",  // 2025
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
            timeZone: "America/New_York", // 🇺🇸 EST
        });
    };


    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">

                    {/* Header */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Video Popup Click Transactions</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">SoComOTT</Link>
                                        </li>
                                        <li className="breadcrumb-item active">Video Popup Click Transactions</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="card">
                        <div className="card-body">

                            {/* Entries */}
                            <div className="row mb-1">
                                <div className="col-md-6">
                                    <label>
                                        Show{" "}
                                        <select
                                            value={itemPerPage}
                                            onChange={(e) => {
                                                setItemPerPage(Number(e.target.value));
                                                setCurrentPage(1);
                                            }}
                                            className="custom-select custom-select-sm mx-2"
                                            style={{ width: "80px" }}
                                        >
                                            <option value="15">15</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        entries
                                    </label>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table  table-centered">
                                    <thead className="thead-light text-center">
                                        <tr>
                                            <th>Product</th>
                                            <th>Video</th>
                                            <th>Network Channel</th>
                                            <th>Channel</th>
                                            <th>Total Clicks</th>
                                            <th>Last Click</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="6" className="text-center fw-bold">
                                                    Loading...
                                                </td>
                                            </tr>
                                        ) : showData.length > 0 ? (
                                            showData.map((item) => {
                                                const lastClick =
                                                    item.clicks?.length > 0
                                                        ? item.clicks[item.clicks.length - 1]
                                                        : null;

                                                return (
                                                    <tr key={item._id} className="text-center">
                                                        <td>{item.productName}</td>
                                                        <td>{item.videoID?.title || "—"}</td>
                                                        <td>{item.networkChannel?.name || "—"}</td>
                                                        <td>{item.subchannelChannel?.name || "—"}</td>

                                                        {/* CLICKABLE */}
                                                        <td
                                                            className="fw-bold text-primary"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => openClicksModal(item)}
                                                        >
                                                            {item.totalClicks}
                                                        </td>


                                                        <td>
                                                            {lastClick ? formatUSDateTime(lastClick.clickedAt) : "No clicks"}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center text-danger fw-bold">
                                                    No Product Click Data Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    Showing{" "}
                                    {Math.min((currentPage - 1) * itemPerPage + 1, data.length)} to{" "}
                                    {Math.min(currentPage * itemPerPage, data.length)} of{" "}
                                    {data.length} entries
                                </div>

                                <div className="col-md-6">
                                    <ul className="pagination justify-content-end">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>
                                                Previous
                                            </button>
                                        </li>

                                        <li className="page-item active">
                                            <span className="page-link">{currentPage}</span>
                                        </li>

                                        <li className={`page-item ${currentPage * itemPerPage >= data.length ? "disabled" : ""}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* 🔥 MODAL */}
            {/* 🔥 MODAL */}
            {showModal && (
                <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,.5)" }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Click Details – {selectedProduct}
                                </h5>
                                <button className="close" onClick={closeClicksModal}>
                                    &times;
                                </button>
                            </div>

                            <div className="modal-body">
                                {/* MODAL TABLE */}
                                <table className="table table-bordered text-center">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>#</th>
                                            <th>IP</th>
                                            <th>Country</th>
                                            <th>City</th>
                                            <th>Clicked At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {modalData.map((click, i) => (
                                            <tr key={i}>
                                                <td>{modalFirstIndex + i + 1}</td>
                                                <td>{click.ipAddress}</td>
                                                <td>{click.country}</td>
                                                <td>{click.city}</td>
                                                <td>{formatUSDateTime(click.clickedAt)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/* 🔹 MODAL PAGINATION */}
                                {selectedClicks.length > modalPerPage && (
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span>
                                            Showing {modalFirstIndex + 1} to{" "}
                                            {Math.min(modalLastIndex, selectedClicks.length)} of{" "}
                                            {selectedClicks.length}
                                        </span>

                                        <ul className="pagination mb-0">
                                            <li className={`page-item ${modalPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => setModalPage(p => p - 1)}
                                                >
                                                    Previous
                                                </button>
                                            </li>

                                            <li className="page-item active">
                                                <span className="page-link">{modalPage}</span>
                                            </li>

                                            <li className={`page-item ${modalLastIndex >= selectedClicks.length ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => setModalPage(p => p + 1)}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={closeClicksModal}>
                                    Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}



            <Footer />
        </div>
    );
}
